import { api } from "@/lib/api";

import type {
  CancelStockAdjustmentReq,
  CreateStockAdjustmentReq,
  GetStockAdjustmentListReq,
  StockAdjustment,
  StockAdjustmentListRes,
} from "@artisancode/api-types";

export const stockAdjustmentService = {
  list: (params?: GetStockAdjustmentListReq) =>
    api.get<StockAdjustmentListRes>(
      "/stock-adjustments",
      params as unknown as Record<
        string,
        string | number | boolean | undefined
      >,
    ),

  detail: (id: string, params?: { workspace_id?: string }) =>
    api.get<StockAdjustment>(
      `/stock-adjustments/${id}`,
      params as Record<string, string | number | boolean | undefined>,
    ),

  create: (body: CreateStockAdjustmentReq, idempotencyKey?: string) =>
    api.post<StockAdjustment>(
      "/stock-adjustments",
      body,
      idempotencyKey ? { "Idempotency-Key": idempotencyKey } : undefined,
    ),

  cancel: (id: string, body: CancelStockAdjustmentReq) =>
    api.post<StockAdjustment>(`/stock-adjustments/${id}/cancel`, body),
};
